import { mapState } from 'vuex'

export default {
  data () {
    return {
      curMenus: null,
      curMenuVersion: null
    }
  },
  computed: {
    ...mapState('menuModule', ['menus', 'latestVersions'])
  },
  watch: {
    latestVersions: function (latestVersions) {
      if (Object.keys(latestVersions).length > 0) {
        this.curMenuVersion = latestVersions
      }
    }
  }

}
